module.exports = __webpack_public_path__ + "img/ai-img-fyj.12e4bf35.png";